<template>
  <div class="anc-container">
      <div class="page-title">
        <div>Manage Announcements</div>
      </div>
      <div class="grid-actions"> <ejs-button type="button" @click.native="onAddNewButtonClick"
                    cssClass="e-info margin-button">New</ejs-button>
      </div>
      <ejs-grid
      :dataSource="listOfAnnouncements"
        :allowSorting="true"
        :allowPaging="true"
        :allowTextWrap="true"
        :toolbar="toolbarOptions"
        :textWrapSettings="wrapSettings"
        :commandClick="commandClick"
      >
        <e-columns>
           <e-column
            headerText="Edit"
           :commands="commands"
            textAlign="center"
            width="100"
          />
          <!-- <e-column field="displayOrder" width="10%" headerText="Display Order" textAlign="Left" /> -->
          <e-column field="title"  headerText="Title" textAlign="Left" />
          <e-column field="type"  headerText="Type" textAlign="Left" />
          <e-column field="startDate"  headerText="Start Date"   type="date"
            :format="gridDateFormat" textAlign="Left"  />
          <e-column field="endDate"  headerText="End Date"   type="date"
             :format="gridDateFormat" textAlign="Left" />
          <!-- <e-column field="disabled" headerText="Disabled?" textAlign="Left" /> -->
          <e-column field="comments" headerText="Comments" textAlign="Left" />
        </e-columns>
      </ejs-grid>
    </div>
</template>

<script>
import Vue from "vue";
import {
  GridPlugin,
  Page,
  Toolbar,
  Edit,
  CommandColumn,
  Sort,
  Search,
  ExcelExport,
} from "@syncfusion/ej2-vue-grids";

import { announcementsAdminApi } from '../services/announcements-api';
import { getDataGridDateFormat } from '../../../utils/date-utils';

Vue.use(GridPlugin);

export default {
  name: 'ManageAnnouncements',
  data() {
    return {
      listOfAnnouncements: [
      ],
      commands: [
        {
          type: 'Edit',
          buttonOption: { cssClass: 'e-flat', iconCss: 'e-edit e-icons' },
        },
      ],
      toolbarOptions: ['Search'],
      wrapSettings: { wrapMode: 'Header' },
      gridDateFormat: getDataGridDateFormat(),
    };
  },
  computed: {
  },
  methods: {
    async setDataOnGrid() {
      this.listOfAnnouncements = await announcementsAdminApi.getAll();
    },
    onAddNewButtonClick() {
      this.$router.push(`/announcements/new`);
    },
    async commandClick(args) {
      switch (args.commandColumn.type) {
        case 'Edit':
          this.openEditForm(args.rowData?.id);
          break;
        default:
          break;
      }
    },
    openEditForm(id) {
      if (id) {
        this.$router.push(`/announcements/${id}`);
      } else console.error('Announcement Id is Missing');
    },
  },
  async created() {
    this.setDataOnGrid();
  },
  provide: {
    grid: [Page, Edit, Toolbar, CommandColumn, Sort, Search, ExcelExport],
  },
};
</script>

<style>

.announcement {
    padding: 15px 25px;
    box-shadow: 1px 1px 4px 0px #d3ad90;
    margin-top: 5px;
    border-radius: 3px;
    font-size: 14px;
    background: #fffed2;
    margin-bottom: 10px;
}
.ann-title {
    font-weight: 600;
    color: #c93204;
    margin-bottom: 5px;
}
.ann-body {
    text-align: justify;
}

.page-title {
    padding: 20px 0px;
    position: relative;
    display: block;
    font-weight: 600;
    font-size: 20px;
    color: #0f4b90;
}

.grid-actions {
  margin-bottom:10px;
}
</style>
